import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "shell-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_ontos_menu_items = _resolveComponent("ontos-menu-items")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_ctx.items.length)
    ? (_openBlock(), _createBlock(_component_v_menu, {
        key: 0,
        location: "bottom end"
      }, {
        activator: _withCtx(({ props }) => [
          (_ctx.$vuetify.display.xs)
            ? (_openBlock(), _createBlock(_component_v_btn, _mergeProps({ key: 0 }, props, {
                variant: "text",
                size: "small",
                icon: _ctx.icon,
                "aria-label": _ctx.label
              }), null, 16, ["icon", "aria-label"]))
            : (_openBlock(), _createBlock(_component_v_btn, _mergeProps({ key: 1 }, props, {
                variant: "text",
                class: "shell-trigger shell-plain-case"
              }), {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    start: "",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.icon), 1)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.label), 1)
                ]),
                _: 1
              }, 16))
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_list, {
            density: "compact",
            nav: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ontos_menu_items, { items: _ctx.items }, null, 8, ["items"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}